import Vue from 'vue';
import axios from 'axios';
import Constants from '@/plugins/constants';
const apiClient = axios.create({
  baseURL: Constants.MAINURL,
  withCredentials: true,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});
var options = {
  persist: true,
};
Vue.use(options);
apiClient.interceptors.request.use(
  function (config) {
    config.headers['Content-Type'] = 'application/json';
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

const state = {
  error400: false,
  error: '',
  successFlag: false,
  token: '',
  outOfServicePhones: [],
  allOutOfServicePhones: [],
  allActiveOutOfServicePhones: [],
  allActiveAlarmOutOfServicePhones: [],
  totalPages: 0,
  totalRecords: 0,
  outOfServicePhone: null,
  errorStatus: null,
};
const getters = {
  getApiLoad_59: (state) => {
    return state.successFlag;
  },
};
const mutations = {
  set_error400(state, error) {
    state.error400 = error;
  },
  SET_Status(state, status) {
    state.successFlag = status;
  },
  SET_Error(state, error) {
    state.error = error;
  },
  SET_errorStatus(state, error) {
    state.errorStatus = error;
  },
  SET_OutOfServicePhones(state, outOfServicePhones) {
    state.outOfServicePhones = outOfServicePhones.items;
    state.totalPages = outOfServicePhones.totalPages;
    state.totalRecords = outOfServicePhones?.totalRecords ?? 0;
  },
  SET_AllOutOfServicePhones(state, outOfServicePhones) {
    state.allOutOfServicePhones = outOfServicePhones;
  },
  SET_OutOfServicePhone(state, outOfServicePhone) {
    state.outOfServicePhone = outOfServicePhone;
  },
  SET_AllActiveOutOfServicePhones(state, outOfServicePhone) {
    state.allActiveOutOfServicePhones = outOfServicePhone;
  },
  SET_AllActiveAlarmOutOfServicePhones(state, outOfServicePhone) {
    state.allActiveAlarmOutOfServicePhones = outOfServicePhone;
  },
};
const actions = {
  errorOutOfServicePhone({ commit }, temperror) {
    var error = temperror;
    if (error) {
      if (error.response) {
        if (error.response.status) {
          if (error.response.status == 401) {
            commit('SET_errorStatus', true);
            commit('set_error400', false);
          } else if (error.response.status == 400) {
            commit('SET_errorStatus', false);
            commit('set_error400', true);
          } else {
            commit('SET_errorStatus', false);
            commit('set_error400', false);
          }
        }
        if (error.response.data) {
          commit('SET_Error', error.response.data.message);
        } else {
          commit('SET_Error', 'عدم ارتباط با سرور');
        }
      } else {
        commit('SET_errorStatus', false);
        commit('set_error400', false);
        commit('SET_Error', 'خطا در برقراری ارتباط با سرور');
      }
      commit('SET_Status', false);
    } else {
      commit('SET_Error', 'خطا امنیتی');
    }
  },
  getAllOutOfServicePhones({ commit, dispatch, rootState }) {
    return apiClient
      .get('/OutOfServicePhones/All', {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_AllOutOfServicePhones', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorOutOfServicePhone', error);
      });
  },
  getAllActiveOutOfServicePhones({ commit, dispatch, rootState }) {
    return apiClient
      .get('/OutOfServicePhones/AllActive', {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_AllActiveOutOfServicePhones', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorOutOfServicePhone', error);
      });
  },
  getAllActiveAlarmOutOfServicePhones({ commit, dispatch, rootState }) {
    return apiClient
      .get('/OutOfServicePhones/AllActiveWithAlarm', {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_AllActiveAlarmOutOfServicePhones', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorOutOfServicePhone', error);
      });
  },
  getOutOfServicePhonesWithPagination(
    { commit, dispatch, rootState },
    { pageNumber, pageSize, title, cityId },
  ) {
    var url =
      '/OutOfServicePhones/AllPagination?pageNumber=' + pageNumber + '&pageSize=' + pageSize;
    if (title) {
      url += '&Title=' + title;
    }
    if (cityId) {
      url += '&CityId=' + cityId;
    }
    return apiClient
      .get(url, { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } })
      .then((response) => {
        commit('SET_OutOfServicePhones', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorOutOfServicePhone', error);
      });
  },
  addOutOfServicePhone({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/OutOfServicePhones', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorOutOfServicePhone', error);
      });
  },
  extendOutOfServicePhone({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/OutOfServicePhones/Extend', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorOutOfServicePhone', error);
      });
  },
  getOutOfServicePhone({ commit, dispatch, rootState }, id) {
    return apiClient
      .get('/OutOfServicePhones/ById?outOfServicePhoneId=' + id, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_OutOfServicePhone', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorOutOfServicePhone', error);
      });
  },
  editOutOfServicePhone({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/OutOfServicePhones/Edit', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorOutOfServicePhone', error);
      });
  },
  endOutOfServicePhone({ commit, dispatch, rootState }, id) {
    return apiClient
      .post(
        '/OutOfServicePhones/End?outOfServicePhoneId=' + id,
        {},
        { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } },
      )
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorOutOfServicePhone', error);
      });
  },
  confirmOutOfServicePhone({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/OutOfServicePhones/Confirm', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorOutOfServicePhone', error);
      });
  },
  cancelOutOfServicePhone({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/OutOfServicePhones/Cancel', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorOutOfServicePhone', error);
      });
  },
};
export default {
  mutations,
  getters,
  state,
  actions,
};
